exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-artist-artist-js": () => import("./../../../src/templates/Artist/Artist.js" /* webpackChunkName: "component---src-templates-artist-artist-js" */)
}

